import React from 'react';
import { theme } from 'styles/theme';
import { useThemeContext } from 'context/ThemeContext/ThemeContext';
import { ReactComponent as LoadingAnimation } from 'assets/icons/svg/loading.svg';

type LoadingIndicatorProps = {
  color?: string;
  size?: string;
  styles?: string;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  color,
  styles = '',
  size = '60px',
}) => {
  const { brandTheme } = useThemeContext();
  return (
    <LoadingAnimation
      className={styles}
      stroke={color || brandTheme || theme.primary}
      height={size}
      width='100%'
      aria-hidden
    />
  );
};

export default LoadingIndicator;
